// extracted by mini-css-extract-plugin
export default {"nav-dropdown":"NavDropdownMenu_nav-dropdown__x-VQg","nav-dropdown-active":"NavDropdownMenu_nav-dropdown-active__eexHm","nav-item-active":"NavDropdownMenu_nav-item-active__pC-pZ"};